var loadComponent = function (route, page) { return function () {
    return import("@/views/" + route + "/pages/" + page + "/entry.vue");
}; };
var toUpperCaseFisrt = function (str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
export function routeClearUp(route, pageName, config) {
    var res = {
        // 所有的一级目录下的 index 页面，皆直接使用当前路由
        path: pageName === 'index' ? "/" + route : "/" + route + "/" + pageName,
        name: "" + toUpperCaseFisrt(route) + toUpperCaseFisrt(pageName),
        component: loadComponent(route, pageName)
    };
    res = Object.assign({}, res, config);
    return res;
}
